import { render, staticRenderFns } from "./EditCompanyProgramName.vue?vue&type=template&id=54cc87da"
import script from "./EditCompanyProgramName.vue?vue&type=script&lang=js"
export * from "./EditCompanyProgramName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports